import React from 'react';
import { Skeleton, Stack } from '@mui/material';
import SkeletonCard from './SkeletonCard';
import SkeletonTable from './SkeletonTable';

interface CardConfig {
  rows: number;
  title?: boolean;
}

interface DetailPageSkeletonProps {
  cards?: CardConfig[];
  showTable?: boolean;
  tableRows?: number;
}

function DetailPageSkeleton({
  cards = [{ rows: 4, title: true }],
  showTable = false,
  tableRows = 3,
}: DetailPageSkeletonProps) {
  return (
    <Stack
      spacing={2}
      sx={{
        marginTop: '0 !important',
      }}
    >
      {/* Back link skeleton */}
      <div>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Skeleton variant="circular" width={20} height={20} />
          <Skeleton variant="text" width={80} height={24} />
        </Stack>
      </div>

      {/* Header skeleton */}
      <Stack sx={{ pl: 2 }} spacing={0.5}>
        <Stack
          alignItems="flex-start"
          direction={{ xs: 'column', md: 'row' }}
          justifyContent="space-between"
          spacing={2}
        >
          <Stack alignItems="center" direction="row" spacing={2}>
            {/* Avatar */}
            <Skeleton variant="circular" width={64} height={64} />
            <Stack spacing={1}>
              {/* Name */}
              <Skeleton variant="text" width={200} height={32} />
              {/* ID chip */}
              <Stack alignItems="center" direction="row" spacing={1}>
                <Skeleton variant="text" width={60} height={20} />
                <Skeleton
                  variant="rectangular"
                  width={120}
                  height={24}
                  sx={{ borderRadius: 1 }}
                />
              </Stack>
            </Stack>
          </Stack>
          {/* Action buttons */}
          <Stack direction="row" spacing={1}>
            <Skeleton
              variant="rectangular"
              width={80}
              height={36}
              sx={{ borderRadius: 1 }}
            />
          </Stack>
        </Stack>
      </Stack>

      {/* Card(s) skeleton */}
      <Stack spacing={2}>
        {cards.map((card, i) => (
          <SkeletonCard key={i} title={card.title} rows={card.rows} />
        ))}
        {showTable && <SkeletonTable rows={tableRows} />}
      </Stack>
    </Stack>
  );
}

export default DetailPageSkeleton;
